let Food = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient;
    let ServiceBaseAddress = serviceAddr;

    /**
     * 获取食疗药膳搜索列表数据
     * @param {any} success
     * @param {any} error
     */
    this.Foods = function (params, success, error) {
        var url = ServiceBaseAddress + '/api/FoodPrescription/Search' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    /**
  * 获取食疗药膳热词数据
  * @param {any} success
  * @param {any} error
  */
    this.Hotspot = function (success, error) {
        var url = ServiceBaseAddress + '/api/FoodPrescription/Hotspot';
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    /**
 * 获取食疗药膳分类
 * @param {any} success
 * @param {any} error
 */
    this.Categorys = function (success, error) {
        var url = ServiceBaseAddress + '/api/FoodPrescription/Categories';
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    /**
     * 获取食疗药膳详情数据
     * @param {any} success
     * @param {any} error
     */
    this.Detail = function (params, success, error) {
        var url = ServiceBaseAddress + '/api/FoodPrescription/' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
}

export { Food }